// api.js
// const BASE_URL = 'https://nirman.csdev.live/api/';
// const BASE_URL = 'http://43.241.69.44/nirman/api/';
// https://dev.siyaram.com/nirman/api/

import Swal from 'sweetalert2';
import { GARMENTUSER } from 'utils/constants';
// export let BASE_URL = '';
const TIMEOUT_DURATION = 5000;

// const NODE_ENV = "Production";
const NODE_ENV = 'development';
export const BASE_URL = 'https://dev.siyaram.com/nirman/api/';
// export const BASE_URL = 'https://sumaglobal.siyaram.com/nirman/api/';

// export const setBaseUrl = (server) => {
//   if(server === "1") {3...............
//     // BASE_URL = 'http://43.241.69.44/nirman/api/';
//     // BASE_URL = 'https://nirman.csdev.live/api/';
//     BASE_URL = 'https://dev.siyaram.com/nirman/api/';
//   } else if(server === "2") {
//     BASE_URL = 'https://sumaglobal.siyaram.com/nirman/api/';
//   } else {
//     BASE_URL = 'https://sumaglobal.siyaram.com/nirman/api/';
//   }

// };

// Retrieve selected server from localStorage if available
// const selectedServer = localStorage.getItem('server');
// if (selectedServer) {
//   console.log("Hello",selectedServer)
//   setBaseUrl(selectedServer);
// }

const showAlert = async (error) => {
  const swalResult = await Swal.fire({
    title: 'Error',
    text: error,
    icon: 'error',
    confirmButtonText: 'Okay',
    customClass: 'sweetalert-bootstrap-modal',
    timer: 2000,
    showConfirmButton: false
  });

  // If you want to perform some action after the alert is closed, you can check the result
  if (swalResult.dismiss === Swal.DismissReason.timer) {
    // console.log('Alert closed after the timer elapsed.');
    // Perform additional actions if needed
  }
};

const handleApiResponse = async (response) => {
  if (!response.ok) {
    //showAlert('Network response was not ok');
    return;
  }

  return await response.json();
};
const handleNetworkError = (error) => {
  // console.error('Check Error :' + error);
  if (error.name === "AbortError") {
    return; // ignore cancelled request
  }

  if (error.message.includes("NetworkError")) {
    return; // firefox temporary network retry
  }

  if (error.message.includes('Failed to fetch')) {
    showAlert('It seems that the connection to server has been lost.');
    return;
  }

  console.log("Error fetching data:", error.message);
};

const bodycontent = (body, url) => {
  const isDevelopment = NODE_ENV === 'development'; // Adjust based on your setup
  const token = isDevelopment ? null : JSON.parse(localStorage.getItem('token'));
  // console.log("token",token);
  if (!navigator.onLine) {
    throw new Error('No internet connection. Please check your network settings.');
  }
  return fetch(BASE_URL + url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...(token && { Authorization: `Bearer ${token}` })
    },
    body: body,
    timeout: TIMEOUT_DURATION
  });
};

const bodycontentnormal = (body, url) => {
  if (!navigator.onLine) {
    throw new Error('No internet connection. Please check your network settings.');
  }
  return fetch(BASE_URL + url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: body,
    timeout: TIMEOUT_DURATION
  });
};

const bodycontentFormData = (body, url) => {
  const isDevelopment = NODE_ENV === 'development'; // Adjust based on your setup
  const token = isDevelopment ? null : JSON.parse(localStorage.getItem('token'));

  console.log(body);
  console.log(url);

  if (!navigator.onLine) {
    throw new Error('No internet connection. Please check your network settings.');
  }

  return fetch(BASE_URL + url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      ...(token && { Authorization: `Bearer ${token}` })
    },
    body: body,
    timeout: TIMEOUT_DURATION
  });
};

// const bodycontentJSON = (body, url) => {
//   console.log(body);
//   if (!navigator.onLine) {
//     throw new Error('No internet connection. Please check your network settings.');
//   }

//   return fetch(BASE_URL + url, {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     body: JSON.stringify(body),
//     timeout: TIMEOUT_DURATION
//   });
// };

const loginApi = async (confCode, userCode, password, deviceInfo, latitude, longitude) => {
  try {
    const response = await bodycontentnormal(`confCode=${confCode}&userCode=${userCode}&password=${password}&source=${'web'}&deviceInfo=${JSON.stringify(deviceInfo)}&latitude=${latitude}&longitude=${longitude}`, 'login.php');
    // console.error('Response:', response);
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const logoutApi = async (userCode, source) => {
  try {
    const response = await bodycontentnormal(`userCode=${userCode}&deviceId=${null}&source=${source}`, 'logout.php');
    // console.error('Response:', response);
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// const forgotPassApi = async (emailId, userCode) => {
//   try {
//     const response = await bodycontentnormal(`userEmailId=${emailId}&userCode=${userCode}`, 'forgotpassword.php');
//     // console.error('Response:', response);
//     return await handleApiResponse(response);
//   } catch (error) {
//     throw handleNetworkError(error);
//   }
// };

// Forgot Password API
const forgotPassApi = async (mobile, userCode) => {
  try {
    const response = await bodycontentnormal(`mobileNo=${mobile}&userCode=${userCode}`, 'otpgeneration.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// OTP Verification API
const otpVerificaionApi = async (mobile, userCode, otp) => {
  try {
    const response = await bodycontentnormal(`mobileNo=${mobile}&userCode=${userCode}&otp=${otp}`, 'otpverify.php');

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// OTP Verification API
const resetPasswordApi = async (userCode, newPassword) => {
  try {
    const response = await bodycontentnormal(`userCode=${userCode}&newPassword=${newPassword}`, 'resetpassword.php');

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getConfData = async () => {
  try {
    // setBaseUrl(String(server));
    // if(String(server) !== '0')
    // {
    const response = await bodycontentnormal('', 'conference.php');
    // console.error('Response:', response);

    return await handleApiResponse(response);
    // }
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getCustomerData = async (userCode, searchText, retries = 3) => {
  const confvalue = JSON.parse(localStorage.getItem('confvalue'));   // ✅ move here

  try {
    const response = await bodycontent(
      `cId=${confvalue?.cID}&userCode=${userCode}&searchVal=${searchText}`,
      'customer.php'
    );

    return await handleApiResponse(response);

  } catch (error) {
    const identifier = `${userCode}-${confvalue?.cID}`;
    await logErrorToApi(error.message, identifier);

    if (retries > 0) {
      console.warn(`Request failed. Retrying... (${retries} retries left)`);
      return await getCustomerData(userCode, searchText, retries - 1);
    } else {
      console.error('All retry attempts failed:', error);
      throw handleNetworkError(error);
    }
  }
};


const getCustomerLeadgerData = async (userCode, searchText, userVertical, retries = 3) => {
  const confvalue = JSON.parse(localStorage.getItem('confvalue'));   // ✅ move here

  try {
    const response = await bodycontent(
      `cId=${confvalue?.cID}&userCode=${userCode}&searchVal=${searchText}&userVertical=${userVertical}`,
      'customerleadger.php'
    );

    return await handleApiResponse(response);

  } catch (error) {
    const identifier = `${userCode}-${confvalue?.cID}`;
    await logErrorToApi(error.message, identifier);

    if (retries > 0) {
      console.warn(`Request failed. Retrying... (${retries} retries left)`);
      return await getCustomerLeadgerData(userCode, searchText, userVertical, retries - 1);
    } else {
      console.error('All retry attempts failed:', error);
      throw handleNetworkError(error);
    }
  }
};


const getAgencyData = async (userCode, retries = 3) => {
  const confvalue = JSON.parse(localStorage.getItem('confvalue'));   // ✅ move here

  try {
    const response = await bodycontent(
      `cId=${confvalue?.cID}&userCode=${userCode}`,
      'agencycode.php'
    );

    return await handleApiResponse(response);

  } catch (error) {
    const identifier = `${userCode}-${confvalue?.cID}`;
    await logErrorToApi(error.message, identifier);

    if (retries > 0) {
      console.warn(`Request failed. Retrying... (${retries} retries left)`);
      return await getAgencyData(userCode, retries - 1);
    } else {
      console.error('All retry attempts failed:', error);
      throw handleNetworkError(error);
    }
  }
};


const logErrorToApi = async (error, data) => {
  try {
    const response = await fetch(BASE_URL + 'log_error.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userCode: data,
        error: error || 'Unknown Error',
        stackTrace: 'No Stack Trace',
        deviceInfo: 'WEB' || 'No Device Info'
      })
    });

    if (response.ok) {
      //console.log("Error logged successfully.");
    } else {
      // console.error("Failed to log error.");
    }
  } catch (loggingError) {
    //console.error("Error logging to the API:", loggingError);
  }
};

const getDistributorData = async (userCode, searchText) => {
  try {
    const confvalue = JSON.parse(localStorage.getItem('confvalue'));
    const response = await bodycontent(`cId=${confvalue.cID}&userCode=${userCode}&searchVal=${searchText}`, 'distributor.php');
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getTransportData = async () => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    const response = await bodycontent(`userCode=${user.userCode}`, 'transport.php');
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getDivisionData = async () => {
  try {
    const response = await bodycontent('', 'division.php');
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getUserDivisionData = async (userCode) => {
  try {
    const response = await bodycontent(`userCode=${userCode}`, 'userdivision.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getCourierData = async () => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    const response = await bodycontent(`userCode=${user.userCode}`, 'courier.php');
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getBarcodeScanData = async (
  partyCode,
  userId,
  customerId,
  barcode = '',
  userCode,
  verticalId,
  fullRange = '',
  multiBarcode = '',
  mainGroup = '',
  allSize = ''
) => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    let filename = '';
    if (user.userVerticalId.toLowerCase().includes(GARMENTUSER.toLowerCase())) {
      filename = 'barcodescan.php';
    } else {
      filename = 'barcodescanfabric.php';
    }

    const response = await bodycontent(
      `partyCode=${partyCode}&userId=${userId}&customerId=${customerId}&div=${user.confSpart}&barcode=${barcode}&userCode=${userCode}&verticalId=${verticalId}&fullRange=${fullRange}&multiBarcode=${multiBarcode}&mainGroup=${mainGroup}&allSize=${allSize}`,
      filename
    );
    // console.error('Response:', response);
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const Order = async (mupdatedList, totalQuantity, orderType, orderNumber, ratioDropdownValue, ratioMultiplier) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const customer = JSON.parse(localStorage.getItem('customer')) || null;
  const distibutor = JSON.parse(localStorage.getItem('distributor'));
  const isRetrieve = JSON.parse(localStorage.getItem('isRetrieve'));
  const retailerName = JSON.parse(localStorage.getItem('retailerName'));
  // const location=JSON.parse(localStorage.getItem('location'));
  const mupdatedListjson = JSON.stringify(mupdatedList);
  const confvalue = JSON.parse(localStorage.getItem('confvalue'));
  const materialList = JSON.parse(localStorage.getItem('materialList'));
  const apId = customer == null ? materialList.materialList[0].apId : customer.apId;
  const orderfrom = localStorage.getItem('orderfrom');
  // console.log("apId",apId);
  // console.log("mupdatedListjson==>"+mupdatedListjson);
  // console.log("orderNumber==>"+orderNumber+","+"user==>"+user+","+"customer==>"+customer+","+"distibutor==>"+distibutor+","+"location==>"+location
  // +","+"totalQuantity==>"+totalQuantity+","+"orderType==>"+orderType);

  const apiFile = String(confvalue.isSFA) === "1"
  ? "orderIsSfa.php"
  : "order.php";

  const isSFAValue = String(confvalue.isSFA) === "1" ? 1 : 0;


  try {
    const response = await bodycontent(
      `cId=${confvalue.cID}&userId=${user.userId}&orderNumber=${orderNumber}&userCode=${user.userCode}&apId=${apId == 'undefined' ? '' : apId
      }&orderfrom=${orderfrom}&partyCode=${customer == null ? materialList.materialList[0].partyCode : customer.partyCode}&dPartyCode=${distibutor == null ? '' : distibutor.value
      }&retailerName=${retailerName}&div=${user.confSpart
      }&orderDetailsListArray=${mupdatedListjson}&totalQuantity=${totalQuantity}&orderType=${orderType}&isRetrieve=${isRetrieve == null ? 0 : isRetrieve
      }&appStatus=${'N'}&ratioDropdownValue=${ratioDropdownValue?.value || null}&ratioMultiplier=${ratioMultiplier || 1}&orderIsSfa=${isSFAValue}`,
      // 'order.php'
      apiFile
    );

    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const CheckoutOrder = async (orderScheduleArray, orderType, formData) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const customer = JSON.parse(localStorage.getItem('customer'));
  //const location=JSON.parse(localStorage.getItem('location'));
  const orderScheduleArrayjson = JSON.stringify(orderScheduleArray);
  const orderId = localStorage.getItem('ordernumber');
  const confvalue = JSON.parse(localStorage.getItem('confvalue'));
  const materialList = JSON.parse(localStorage.getItem('materialList'));

  try {
    const response = await bodycontent(
      `cId=${confvalue.cID}&userCode=${user.userCode}&partyCode=${customer == null ? materialList.materialList[0].partyCode : customer.partyCode
      }&orderId=${orderId}&dispatchReason=${formData.dispatchReason.value}&orderScheduleArray=${orderScheduleArrayjson}&name=${formData.name}&emailId=${formData.email}&note=${formData.note
      }&orderType=${orderType}`,
      'checkoutorder.php'
    );
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const FabricCheckoutOrder = async (formData, orderType) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const customer = JSON.parse(localStorage.getItem('customer'));
  //const location=JSON.parse(localStorage.getItem('location'));
  const orderId = localStorage.getItem('ordernumber');
  const confvalue = JSON.parse(localStorage.getItem('confvalue'));
  const materialList = JSON.parse(localStorage.getItem('materialList'));
  // console.log("customer",customer)
  try {
    const response = await bodycontent(
      `userCode=${user.userCode}&partyCode=${customer == null ? materialList.materialList[0].partyCode : customer.partyCode}&cId=${confvalue.cID
      }&orderId=${orderId}&dispatchWeek=${formData.dispatchWeek.value}&dispatchMonth=${formData.dispatchMonth.label + ' ' + formData.dispatchYear.value
      }&dispatchStatus=${formData.dispatchStatus}&dispatchReason=${formData.dispatchReason.value}&note=${formData.note}&emailId=${formData.emailId
      }&sampleRequired=${formData.sampleRequired}&orderType=${orderType}&blackRequired=${formData.blackRequired}`,
      'checkoutorder.php'
    );
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getOrdersData = async (userCode, apId) => {
  const confvalue = JSON.parse(localStorage.getItem('confvalue'));

  try {
    const response = await bodycontent(`userCode=${userCode}&cId=${confvalue.cID}&partyCode=${apId}`, 'orderlist.php');
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getOrderDetails = async (orderId) => {
  try {
    const response = await bodycontent(`orderId=${orderId}`, 'orderdetails.php');
    // console.error('Response:', response);
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getReplicateOrderDetails = async (orderId) => {
  try {
    const response = await bodycontent(`orderId=${orderId}`, 'orderdetailsreplicate.php');
    // console.error('Response:', response);
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getRetriveDetails = async (partyCode, materialVertical) => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    const response = await bodycontent(
      `userCode=${user.userCode}&partyCode=${partyCode}&materialVertical=${materialVertical}`,
      'retrievelist.php'
    );
    // console.error('Response:', response);
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getOrderReasonData = async () => {
  try {
    const response = await bodycontent('', 'orderreasonlist.php');
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const downalodFabricPdf = async (orderId, orderNumber, fileName) => {
  try {
    const response = await fetch(BASE_URL + fileName, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: `orderId=${orderId}`
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const blob = await response.blob();

    // Create a link element and trigger a download
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = orderNumber + '.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Return true when the download is complete
    return true;
  } catch (error) {
    // console.error('Error downloading PDF:', error);
    throw new Error('Download failed');
  }
};

const attedancereportData = async () => {
  const user = JSON.parse(localStorage.getItem('user'));

  try {
    const response = await bodycontent(`userId=${user.userId}`, 'myattendancereport.php');
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const myordersreportData = async (conferenceFilter, customerFilter, orderNumberFilter, orderDateFilter) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const confvalue = JSON.parse(localStorage.getItem('confvalue'));

  // Extract values safely
  let conference = conferenceFilter?.value || '';
  const customer = customerFilter?.value || '';
  const orderNumber = orderNumberFilter || '';
  const orderDate = orderDateFilter || '';

  if (conference == "123") {
    conference = '';
  }


  try {
    const response = await bodycontent(
      `userCode=${user.userCode}` +
      `&cId=${confvalue.cID}` +
      `&cIdFilter=${conference}` +
      `&partyCodeFilter=${customer}` +
      `&orderNumber=${orderNumber}` +
      `&orderCreateddate=${orderDate}`,
      'myorderreport.php'
    );

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};


// const CustomerProfileApi = async (formData) => {

//   try {
//     const user=JSON.parse(localStorage.getItem('user'));
//     const response = await bodycontent(`userCode=${user.userCode}&gstInNumber=${formData.gstInNumber}&uploaded_file_gst=${formData.uploaded_file_gst}&customerName=${formData.customerName}&address1=${formData.address1}&address2=${formData.address2}&address3=${formData.address3}&pinCode=${formData.pinCode}&city=${formData.city}&district=${formData.district}&state=${formData.state}&contactPersonFullName=${formData.contactPersonFullName}&telephoneNumber=${formData.telephoneNumber}&mobileNo=${formData.mobileNo}&billTo=${formData.billTo.value}&payTo=${formData.payTo.value}&emailAddress=${formData.emailAddress}&panNumber=${formData.panNumber}&uploaded_file_pan=${formData.uploaded_file_pan}&aadharNumber=${formData.aadharNumber}&uploaded_file_aadhar=${formData.uploaded_file_aadhar}&salesOfficerName=${formData.salesOfficerName}&transportName=${formData.transportName.value}&courierName=${formData.courierName.value}&transportDestinationFrom=${formData.transportDestinationFrom.value}&transportDestinationTo=${formData.transportDestinationTo}&maxCaseOneLr=${formData.maxCaseOneLr.value}&customerCategory=${formData.customerCategory.value}&bankName=${formData.bankName}&bankBranchAddress=${formData.bankBranchAddress}&bankAccountNumber=${formData.bankAccountNumber}&ifscCode=${formData.ifscCode}&micrCode=${formData.micrCode}`,'customerprofile.php');

//     // console.error('Response:', response);

//     return await handleApiResponse(response);
//   } catch (error) {
//     throw handleNetworkError(error);
//   }
// };

const CustomerProfileApi = async (formData) => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    const requestBody = new FormData();

    // Append form fields to FormData
    requestBody.append('userCode', user.userCode);
    requestBody.append('gstInNumber', formData.gstInNumber);
    requestBody.append('customerName', formData.customerName);
    requestBody.append('address1', formData.address1);
    requestBody.append('address2', formData.address2);
    requestBody.append('address3', formData.address3);
    requestBody.append('pinCode', formData.pinCode);
    requestBody.append('city', formData.city);
    requestBody.append('district', formData.district);
    requestBody.append('state', formData.state);
    requestBody.append('contactPersonFullName', formData.contactPersonFullName);
    requestBody.append('telephoneNumber', formData.telephoneNumber);
    requestBody.append('mobileNo', formData.mobileNo);
    requestBody.append('billTo', formData.billTo ? formData.billTo.value : '');
    requestBody.append('payTo', formData.payTo ? formData.payTo.value : '');
    requestBody.append('bptype', formData.bpType ? formData.bpType.value : '');
    requestBody.append('emailAddress', formData.emailAddress);
    requestBody.append('panNumber', formData.panNumber);
    requestBody.append('aadharNumber', formData.aadharNumber.replace(/\s/g, '')); // Removes any spaces from aadhar number
    requestBody.append('salesOfficerName', formData.salesOfficerName);
    requestBody.append('agencyCode', formData.agencyCode ? formData.agencyCode.value : '');
  //  requestBody.append('division', formData.division ? formData.division.value : '');
    requestBody.append('transportName', formData.transportName ? formData.transportName.value : '');
    requestBody.append('courierName', formData.courierName ? formData.courierName.value : '');
    requestBody.append('transportDestinationFrom', formData.transportDestinationFrom ? formData.transportDestinationFrom.value : '');
    requestBody.append('transportDestinationTo', formData.transportDestinationTo);
    requestBody.append('maxCaseOneLr', formData.maxCaseOneLr ? formData.maxCaseOneLr.value : '');
    requestBody.append('customerCategory', formData.customerCategory ? formData.customerCategory.value : '');
    requestBody.append('bankName', formData.bankName);
    requestBody.append('bankBranchAddress', formData.bankBranchAddress);
    requestBody.append('bankAccountNumber', formData.bankAccountNumber);
    requestBody.append('ifscCode', formData.ifscCode);
    requestBody.append('micrCode', formData.micrCode);

    // Append files (GST, PAN, Aadhar) if they exist
    if (formData.uploaded_file_gst) {
      requestBody.append('uploaded_file_gst', formData.uploaded_file_gst);
    }

    if (formData.uploaded_file_pan) {
      requestBody.append('uploaded_file_pan', formData.uploaded_file_pan);
    }

    if (formData.uploaded_file_aadhar) {
      requestBody.append('uploaded_file_aadhar', formData.uploaded_file_aadhar);
    }

    // Make API request
    const response = await bodycontentFormData(requestBody, 'customerprofile.php');

    console.log(response);

    // Handle the API response
    return await handleApiResponse(response);
  } catch (error) {
    // Handle any network or response errors
    throw handleNetworkError(error);
  }
};

const getCustomerProfileDetails = async (gstInNumber, panNumber = '') => {
  try {
    const response = await bodycontent(`gstInNumber=${gstInNumber}&panNumber=${panNumber}`, 'customerprofiledetails.php');

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const sendExtendCustomerProfileData = async (userCode, email, gstin, pan,division) => {
  try {
    const response = await bodycontent(
      `usercode=${userCode}&mailid=${email}&gstInNumber=${gstin}&panNumber=${pan}&division=${division}`,
      'customerprofiledetails.php'
    );
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const sampleCheckScanData = async (partyCode, userCode, verticalId, multiBarcode = '') => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    let filename = 'samplecheck.php';

    const response = await bodycontent(
      `partyCode=${partyCode}&userCode=${userCode}&verticalId=${verticalId}&div=${user.confSpart}&multiBarcode=${multiBarcode}`,
      filename
    );
    // console.error('Response:', response);
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};
const stockUpload = async (fileInput, userCode) => {
  try {
    const formData = new FormData();
    formData.append('uploaded_file', fileInput);
    formData.append('userCode', userCode);
    const response = await uplaodbodycontent(formData, 'Admin/barcodeCsvUpload.php');
    // console.error('Response:', response);
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};
const uplaodbodycontent = (body, url) => {
  const isDevelopment = NODE_ENV === 'development';
  const token = isDevelopment ? null : JSON.parse(localStorage.getItem('token'));
  // console.log("token",token);
  if (!navigator.onLine) {
    throw new Error('No internet connection. Please check your network settings.');
  }
  return fetch(BASE_URL + url, {
    method: 'POST',
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }) // Add token header only if not in development
    },
    body: body

    //  timeout:TIMEOUT_DURATION
  });
};

const salesOrderUpload = async (fileInput) => {
  try {
    // const location=JSON.parse(localStorage.getItem('location'));
    const user = JSON.parse(localStorage.getItem('user'));
    const confvalue = JSON.parse(localStorage.getItem('confvalue'));
    let orderType;
    if (user.userVerticalId.toLowerCase().includes(GARMENTUSER.toLowerCase())) {
      orderType = 'garment';
    } else {
      orderType = 'fabric';
    }
    const formData = new FormData();
    formData.append('uploaded_file', fileInput);
    formData.append('userCode', user.userCode);
    formData.append('userId', user.userId);
    formData.append('cId', confvalue.cID);
    formData.append('verticalId', user.userVerticalId);
    formData.append('orderType', orderType);
    // formData.append('orderLatitude', location.latitude);
    // formData.append('orderLongitude', location.longitude);
    // formData.append('orderLocation', location.address);

    const response = await uplaodbodycontent(formData, 'saleOrderUploadCsv.php');
    // console.error('Response:', response);
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const cancelOrderAPI = async (orderId, userCode) => {
  try {
    const response = await bodycontent(`orderId=${orderId}&userCode=${userCode}`, 'cancelOrder.php');
    // console.error('Response:', response);
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getLedgerData = async (partyCode) => {
  try {
    const response = await bodycontent(`partyCode=${partyCode}`, 'ledger.php');
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getLedgerDivData = async (partyCode, verticalId, profitCenter, isSFA) => {
  try {
    const response = await bodycontent(
      `partyCode=${partyCode}&userVertical=${verticalId}&profitCenter=${profitCenter}&isSFA=${isSFA}`,
      'ledgerDiv.php'
    );
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};
const getVendorLedgerData = async (partyCode) => {
  try {
    const response = await bodycontent(`partyCode=${partyCode}`, 'partyvendorledger.php');
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getLedgerDetails = async (partyCode, month, year, opening) => {
  try {
    const response = await bodycontent(`partyCode=${partyCode}&month=${month}&year=${year}&opening=${opening}`, 'ledgerDetails.php');
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getLedgerDivDetails = async (partyCode, month, year, opening, userVertical, profitCenter, isSFA) => {
  try {
    // const profitCentersArr = profitCenters.join(',');

    const response = await bodycontent(
      `partyCode=${partyCode}&month=${month}&year=${year}&opening=${opening}&userVertical=${userVertical}&profitCenter=${profitCenter}&isSFA=${isSFA}`,
      'ledgerDivDetails.php'
    );
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getPreviousLedgerData = async (partyCode) => {
  try {
    const response = await bodycontent(`partyCode=${partyCode}`, 'previousledger.php');
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};
const getPreviousLedgerDetails = async (partyCode, month, year, opening) => {
  try {
    const response = await bodycontent(
      `partyCode=${partyCode}&month=${month}&year=${year}&opening=${opening}`,
      'previousledgerDetails.php'
    );
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getVendorLedgerDetails = async (partyCode, month, year, opening) => {
  try {
    const response = await bodycontent(
      `partyCode=${partyCode}&month=${month}&year=${year}&opening=${opening}`,
      'partyvendorledgerDetails.php'
    );
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const downloadFiles = async (param, url, filename) => {
  try {
    const response = await fetch(BASE_URL + url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: param
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    // console.log(response);
    const blob = await response.blob();

    // Create a link element and trigger a download
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return true;
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const stockDownload = async (param, url, filename) => {
  try {
    const response = await fetch(BASE_URL + url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: param
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    // console.log(response);
    const blob = await response.blob();

    // Create a link element and trigger a download
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return true;
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const pendingOrdersDownload = async (param, url, filename) => {
  try {
    const response = await fetch(BASE_URL + url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: param
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    // console.log(response);
    const blob = await response.blob();

    // Create a link element and trigger a download
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return true;
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const pincodeData = async (pincode) => {
  try {
    const response = await bodycontent(`pincode=${pincode}`, 'postalpincode.php');
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getAssessmentScanData = async (multiBarcode = '', verticalId) => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    let filename = 'scan_assessment.php';
    const response = await bodycontent(`div=${user.confSpart}&verticalId=${verticalId}&multiBarcode=${multiBarcode}`, filename);
    // console.error('Response:', response);
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const addAssessmentScanData = async (payloaddata) => {
  try {
    let filename = 'add_assessment.php';
    const response = await bodycontent(`data=${payloaddata}`, filename);
    // console.error('Response:', response);
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getDivisionWiseOutstanding = async (partyCode, profitCenter,userVerticalId, isSFA) => {
  try {
    const response = await bodycontent(
      `partyCode=${partyCode}&profitCenter=${profitCenter}&userVertical=${userVerticalId}&isSFA=${isSFA}`,
      'outstanding.php'
    );
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getDivisionWiseOutstandingNew = async (partyCode, profitCenter,confvertical, isSFA) => {
  try {
    const response = await bodycontent(
      `partyCode=${partyCode}&profitCenter=${profitCenter}&userVertical=${confvertical}&isSFA=${isSFA}`,
      'divisionWiseOutstanding.php'
    );
    // console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getAssessmentReports = async (conferenceId, userCode) => {
  try {
    const response = await bodycontent(`conferenceId=${conferenceId}&userCode=${userCode}`, 'Admin/getAssessmentsList.php');

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Show planed beats
const fetchUserBeats = async (userCode, selectedDate) => {
  try {
    const response = await bodycontent(`user_code=${userCode}&date=${selectedDate}`, 'beats/fetchuserbeats.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Show beats for planning
const fetchPlanningBeats = async (userCode) => {
  try {
    const response = await bodycontent(`user_code=${userCode}`, 'beats/fetchuserplanningbeats.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchBeatCustomers = async (beatCode, userCode) => {
  try {
    const response = await bodycontent(`beat_code=${beatCode}&user_code=${userCode}`, 'beats/fetchcustomerdetails.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Upload Beats plan
const uploadBeatPlanning = async (beatCodes, selectedDateList, userCode) => {
  try {
    // Create form-encoded body
    const formData = new URLSearchParams();
    formData.append('user_code', userCode);

    // Append beats[] values
    beatCodes.forEach((beat) => formData.append('beats[]', beat));

    // Append dates[] values
    selectedDateList.forEach((date) => {
      const parts = date.split('/');
      if (parts.length === 3) {
        const formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`; // yyyy-mm-dd
        formData.append('dates[]', formattedDate);
      } else {
        formData.append('dates[]', date); // fallback if not in expected format
      }
    });

    const response = await bodycontent(formData.toString(), 'beats/planuservisits.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const uploadBeatCustomerVisitRemark = async (
  userCode,
  beatCode,
  partyCode,
  visitStatus,
  visitRemark,
  visitDate,
  latitude,
  longitude,
  location,
  selectedPlant,
  user_type
) => {
  try {
    // const response = await bodycontent(`user_code=${userCode}&beat_code=${beatCode}&party_code=${partyCode}&visit_status=${visitStatus}&visit_remarks=${visitRemark}&visit_date=${visitDate}&latitude=${latitude}&longitude=${longitude}&location=${location}`, 'beats/insertvisitstatus.php');
    const response = await bodycontent(
      `user_code=${userCode}&beat_code=${beatCode}&party_code=${partyCode}&visit_status=${visitStatus}&visit_remarks=${visitRemark}&visit_date=${visitDate}&latitude=${latitude}&longitude=${longitude}&location=${location}&visitplantid=${selectedPlant}&user_type=${user_type}`,
      'beats/insertvisitstatus.php'
    );
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchBeatCustomerOutstandingReport = async (userCode, partyCode) => {
  try {
    const response = await bodycontent(`userCode=${userCode}&partyCode=${partyCode}`, 'reports/outstanding_report.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchBeatCustomerSalesCompReport = async (userCode, partyCode) => {
  try {
    const response = await bodycontent(`user_code=${userCode}&party_code=${partyCode}`, 'reports/sales_comparison_report.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchBeatCustomerCategoryCompReport = async (userCode, partyCode) => {
  try {
    const response = await bodycontent(`user_code=${userCode}&party_code=${partyCode}`, 'reports/category_wise_sales_report.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchTargetSaleReport = async (userCode, partyCode) => {
  try {
    const response = await bodycontent(`user_code=${userCode}&party_code=${partyCode}`, 'reports/targetsales_report.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchProfitCenters = async (profitCenters) => {
  try {
    const response = await bodycontent(`profit_centers=${profitCenters}`, 'getProfitCenters.php');

    return await handleApiResponse(response);
    // return response;
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchPlantVisit = async () => {
  try {
    const response = await bodycontent(``, 'beats/getplantvisitlist.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

//Market Intelliagence
const fetchSubject = async () => {
  try {
    const response = await bodycontent(``, 'beats/getsubject.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
}
const fetchDivision = async () => {
  try {
    const response = await bodycontent(``, 'getDivisionDropdown.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
}
const fetchUsers = async (search) => {
  try {
    const response = await bodycontent(`search=${search}`, 'searchUser.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
}

const postMarketIntelliagence = async (formData) => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    const requestBody = new FormData();

    // Append form fields to FormData
    requestBody.append('user_code', user.userCode);
    requestBody.append('subject_id', formData.subject.value);
    requestBody.append('division', formData.division);
    requestBody.append('handover_person_code', formData.user);
    requestBody.append('remark', formData.remark);
    requestBody.append('price_cost_meter', formData.price_cost_meter || "");
    requestBody.append('physical_item_collected', formData.isPhysicalItemCollected);

    if (formData.uploaded_file && formData.uploaded_file.length > 0) {
      formData.uploaded_file.forEach((file, idx) => {
        requestBody.append(`file${idx + 1}`, file); // file1, file2, file3
      });
    }

    // Make API request
    const response = await bodycontentFormData(requestBody, 'beats/insertmarketintelligence.php');

    // Handle the API response
    return await handleApiResponse(response);
  } catch (error) {
    // Handle any network or response errors
    throw handleNetworkError(error);
  }
};

const ProductCatalogueCSVUpload = async (fileInput, userCode) => {
  try {
    const formData = new FormData();
    formData.append('file', fileInput);
    formData.append('user_code', userCode);

    // ✅ Correct backend URL
    const response = await uplaodbodycontent(formData, 'pdf/uploadproductcatalogcsv.php');


    // ✅ Handle non-200 responses
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    // ✅ Convert to Blob (binary data for PDF)
    const blob = await response.blob();

    // ✅ Extract filename from Content-Disposition header (if provided)
    const contentDisposition = response.headers.get('Content-Disposition');
    let filename = 'ProductCatalog.pdf';
    if (contentDisposition && contentDisposition.includes('filename=')) {
      filename = contentDisposition.split('filename=')[1].replace(/["']/g, '');
    }

    // ✅ Trigger download in browser
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return {
      success: 'true',
      msg: 'Product Catalogue Uploaded Successfully',
    };
  } catch (error) {
    console.error('Error uploading or downloading file:', error);

    return {
      success: 'false',
      msg: 'Failed to upload Product Catalogue',
    };
  }
};

const fetchUserReports = async () => {
  // try {
  //   const response = await bodycontent(`user_code=${userCode}&party_code=${partyCode}`, 'beats/category_wise_sales_report.php');
  //   return await handleApiResponse(response);
  // } catch (error) {
  //   throw handleNetworkError(error);
  // }
};

// REPORT APIs
// Target vs Achievement API
const fetchTargetAchievementReport = async (userCode) => {
  try {
    const response = await bodycontent(`party_code=${userCode}`, 'targetAchievementReports.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Collections API
const fetchCollectionsReport = async (userCode) => {
  try {
    const response = await bodycontent(`party_code=${userCode}`, 'collectionsReport.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Pending vs Dispatch API
const fetchPendingDispatchReport = async (userCode) => {
  try {
    const response = await bodycontent(`party_code=${userCode}`, 'pendingDispatchReports.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Pending vs Dispatch API
const fetchOutstandingReport = async (userCode) => {
  try {
    const response = await bodycontent(`party_code=${userCode}`, 'outstandingReport.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Pending vs Dispatch API
const fetchSalesReport = async (userCode) => {
  try {
    const response = await bodycontent(`party_code=${userCode}`, 'salesReport.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Stock Level API
const fetchStockLevelReport = async (userCode) => {
  try {
    const response = await bodycontent(`party_code=${userCode}`, 'stockLevel.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Sample Request APIs
// get Barcode Data
const fetchSampleRequestBarcodesData = async (userId, barcode, userCode, verticalId, multiBarcode, mainGroup) => {
  console.log('fetchSampleRequestBarcodesData api Design Number in Controller-----', mainGroup);
  try {
    const response = await bodycontent(`userId=${userId}&barcode=${barcode}&userCode=${userCode}&verticalId=${verticalId}&multiBarcode=${multiBarcode}&mainGroup=${mainGroup}`, 'sampleRequestBarcodescan.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};
const fetchSalesPlanningBarcodesData = async (userId, barcode, userCode, verticalId, multiBarcode, mainGroup) => {
  console.log('fetchSampleRequestBarcodesData api Design Number in Controller-----', mainGroup);
  try {
    const response = await bodycontent(`userId=${userId}&barcode=${barcode}&userCode=${userCode}&verticalId=${verticalId}&multiBarcode=${multiBarcode}&mainGroup=${mainGroup}`, 'salesPlanningBarcodescan.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// fetch Sample Types
const fetchSampleTypes = async () => {
  try {
    const response = await bodycontent(``, 'sampleType.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

//sample request order
const proceedsamplerequestorder = async ({
  userCode,
  apId,
  partyCode,
  conferenceId,
  sampleCategory,
  remark,
  sampleOrderDetailsListArray
}) => {
  try {
    const body =
      `userCode=${encodeURIComponent(userCode)}` +
      `&apId=${encodeURIComponent(apId)}` +
      `&partyCode=${encodeURIComponent(partyCode)}` +
      `&conferenceId=${encodeURIComponent(conferenceId)}` +
      `&sampleCategory=${encodeURIComponent(sampleCategory)}` +
      `&remark=${encodeURIComponent(remark)}` +
      `&sampleOrderDetailsListArray=${encodeURIComponent(
        JSON.stringify(sampleOrderDetailsListArray) // JSON object → string
      )}`;

    console.log("FINAL BODY →", body);
    const response = await bodycontent(body, "sampleRequestOrder.php");
    return await response.json();

  } catch (err) {
    console.error("API ERROR:", err);
    throw err;
  }
};

const submitSampleRequestRemarkAPI = async (sampleRequestId, remark) => {
  try {
    const response = await bodycontent(`samReqOrderId=${sampleRequestId}&remarks=${remark}`, 'pdf/sampleRequestOrderSavePdf.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};


// Stock selection Garment Ratio
const fetchRatioOptions = async (wearType) => {
  try {
    const response = await bodycontent(`wearType=${wearType}`, 'ratioOptions.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// fetch three months for sample request
const fetchSampleRequestMonths = async () => {
  try {
    const response = await bodycontent(``, 'getThreeMonthsAfterCurrentMonth.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const proceedsamplerequestorder90days = async ({
  userCode,
  conferenceId,
  remark,
  sampleOrderDetails90DayListArray
}) => {
  try {
    const body =
      `userCode=${encodeURIComponent(userCode)}` +
      `&conferenceId=${encodeURIComponent(conferenceId)}` +
      `&remark=${encodeURIComponent(remark)}` +
      `&sampleOrderDetails90DayListArray=${encodeURIComponent(
        JSON.stringify(sampleOrderDetails90DayListArray)
      )}`;

    // console.log("FINAL BODY →", body);
    const response = await bodycontent(body, "sampleRequest90DayOrder.php");
    // console.log('response api service-',response.message);
    // console.log('response api service-',response.success);
    return await handleApiResponse(response);

  } catch (err) {
    console.error("API ERROR:", err);
    throw err;
  }
};

// Pending vs Dispatch API
const postGoodAndReturns = async (usercode, value, label) => {
  try {
    const response = await bodycontent(`userCode=${usercode}&value=${value}&label=${label}`, 'processgoodsreturns.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Fetch Dynamic Report Data
const getSample90DaysMonthsReport = async (userCode, materialCode, materialDesc, mainGroup, barcode) => {
  try {
    const response = await bodycontent(`userCode=${userCode}&materialCode=${materialCode}&materialDesc=${materialDesc}&mainGroup=${mainGroup}&barcode=${barcode}`, 'sampleRequest90DaysReport.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const getSampleRequestAccessAPI = async (userCode, conferenceId) => {
  try {
    const response = await bodycontent(`userCode=${userCode}&conferenceId=${conferenceId}`, 'checksamplerequest90daysaccess.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// fetch user parties
const fetchUserParties = async (userCode) => {
  try {
    const response = await bodycontent(`userCode=${userCode}`, 'getUserReportsPartyCodes.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// upload Goods Return Info
const uploadGoodsReturnInfoDetails = async (formData) => {
  try {
    const requestBody = new FormData();

    // --------------------
    // Goods Return Info
    // --------------------
    requestBody.append('return_option', formData.return_option);
    requestBody.append('order_number', formData.order_number);
    requestBody.append('user_code', formData.user_code);
    requestBody.append('party_code', formData.party_code);
    requestBody.append('from_party_code', formData.from_party_code);
    requestBody.append('delivery_number', formData.delivery_number);
    requestBody.append('invoice_number', formData.invoice_number);
    requestBody.append('invoice_date', formData.invoice_date);
    requestBody.append('materialInfoListArray', JSON.stringify(formData.materialInfoDetails));

    // --------------------
    // Transfer Details
    // --------------------
    // ✅ JSON string for material list
    // requestBody.append(
    //   'materialInfoListArray',
    //   JSON.stringify({
    //     materialInfoDetails: formData.materialInfoDetails.map(item => ({
    //       material_code: item.material_code,
    //       material_description: item.material_desc,
    //       barcode: item.barcode,
    //       quantity: item.quantity,
    //       batch: item.batch,
    //     })),
    //   })
    // );

    // --------------------
    // Files (PDF)
    // --------------------
    // if (formData.lr_copy) {
    //   requestBody.append('lr_copy', formData.lr_copy); // File object
    // }

    // if (formData.debit_note_copy) {
    //   requestBody.append('debit_note_copy', formData.debit_note_copy); // File object
    // }

    // --------------------
    // API CALL
    // --------------------
    const response = await bodycontentFormData(
      requestBody,
      'goods_return_info.php'
    );

    return await handleApiResponse(response);

  } catch (error) {
    throw handleNetworkError(error);
  }
}

// submit goods return transfer details
const uploadGoodsReturnTransferDetails = async (formData) => {

  try {
    const requestBody = new FormData();

    // --------------------
    // Goods Return Info
    // --------------------
    requestBody.append('deliveryNo', formData.deliveryNumber);
    // requestBody.append('return_option', formData.return_option);
    // requestBody.append('order_number', formData.order_number);
    requestBody.append('user_code', formData.user_code);
    requestBody.append('party_code', formData.party_code);
    requestBody.append('from_party_code', formData.from_party_code);
    // requestBody.append('deliveryNo', formData.delivery_number);
    requestBody.append('invoice_number', formData.invoice_number);
    requestBody.append('goodsReturnInvoiceDtlsId', formData.goodsReturnInvoiceDtlsId);
    // requestBody.append('invoice_date', formData.invoice_date);
    // requestBody.append('barcode', formData.barcode);
    // requestBody.append('quantity', formData.quantity);
    // requestBody.append('material_code', formData.material_code);
    // requestBody.append('material_description', formData.material_description);
    // requestBody.append('batch', formData.batch);

    // --------------------
    // Transfer Details
    // --------------------
    requestBody.append('lr_number', formData.lr_number);
    requestBody.append('lr_date', formData.lr_date);
    requestBody.append('transporter', formData.transporter);
    requestBody.append('e_way_bill', formData.e_way_bill);
    requestBody.append('discount_percentage', formData.discount_percentage || 0);

    // --------------------
    // Files (PDF)
    // --------------------
    if (formData.lr_copy) {
      requestBody.append('lr_copy', formData.lr_copy); // File object
    }

    if (formData.debit_note_copy) {
      requestBody.append('debit_note_copy', formData.debit_note_copy); // File object
    }

    // --------------------
    // API CALL
    // --------------------
    const response = await bodycontentFormData(
      requestBody,
      'goods_return_transfer.php'
    );

    return await handleApiResponse(response);

  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchZonesPOReports = async (userCode, type = "collection") => {
  try {
    const response = await bodycontent(`userCode=${userCode}&type=${type}`, 'reports/zones.php');
    console.log('zone dropdown', response)
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
}

const fetchZonePartiesPOReports = async (userCode, { search = "", type = "collection" }) => {
  try {
    const response = await bodycontent(`userCode=${userCode}&search=${search}&type=${type}`, 'reports/zoneparties.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
}

const fetchDescriptionPOReports = async (userCode) => {
  try {
    const response = await bodycontent(`userCode=${userCode}`, 'reports/descriptions.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
}

const fetchSubdivisionPOReports = async (userCode, type = "collection") => {
  try {
    const response = await bodycontent(`userCode=${userCode}&type=${type}`, 'reports/subdivision.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
}

const fetchPendingOrderReports = async (
  userCode,
  page,
  zone,
  partyCode,
  division,
  status,
  description,
  fromDate,
  toDate
) => {
  const params =
    `userCode=${encodeURIComponent(userCode)}` +
    `&page=${encodeURIComponent(page)}` +
    `&zone=${encodeURIComponent(zone || "")}` +
    `&partyCode=${encodeURIComponent(partyCode || "")}` +
    `&division=${encodeURIComponent(division || "")}` +
    `&status=${encodeURIComponent(status || "")}` +
    `&description=${encodeURIComponent(description || "")}` +
    `&from_date=${encodeURIComponent(fromDate || "")}` +
    `&to_date=${encodeURIComponent(toDate || "")}`;

  const response = await bodycontent(params, "reports/pendingorderreport.php");
  return handleApiResponse(response);
};

const fetchOutstandingReports = async (
  userCode,
  page,
  zone,
  division,
  partyCode,
  fromDate,
  toDate
) => {
  const params =
    `userCode=${encodeURIComponent(userCode)}` +
    `&page=${encodeURIComponent(page)}` +
    `&zone=${encodeURIComponent(zone || "")}` +
    `&division=${encodeURIComponent(division || "")}` +
    `&party=${encodeURIComponent(partyCode || "")}` +
    `&from_date=${encodeURIComponent(fromDate || "")}` +
    `&to_date=${encodeURIComponent(toDate || "")}`;

  const response = await bodycontent(params, "reports/outstandingreport.php");
  return handleApiResponse(response);
};

const fetchNonBilledReports = async (
  userCode,
  customerCode,
  division,
  fromDate,
  toDate
) => {
  const params =
    `userCode=${encodeURIComponent(userCode || "")}` +
    `&customer_code=${encodeURIComponent(customerCode || "")}` +
    `&division=${encodeURIComponent(division || "")}` +
    `&from_date=${encodeURIComponent(fromDate || "")}` +
    `&to_date=${encodeURIComponent(toDate || "")}`;

  const response = await bodycontent(params, "nonbilledreport.php");
  return handleApiResponse(response);
};


const fetchAllConferenceList = async () => {
  try {
    const response = await bodycontent(``, 'Admin/conferencelist.php');
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
}

const fetchCollectionReceivedReports = async (
  userCode,
  page,
  zone,
  partyCode,
  fromDate,
  toDate,
  year,
  month
) => {
  const params =
    `userCode=${encodeURIComponent(userCode)}` +
    `&page=${encodeURIComponent(page)}` +
    `&zone=${encodeURIComponent(zone || "")}` +
    `&party=${encodeURIComponent(partyCode || "")}` +
    `&from_date=${encodeURIComponent(fromDate || "")}` +
    `&to_date=${encodeURIComponent(toDate || "")}` +
    `&year=${encodeURIComponent(year || "")}` +
    `&month=${encodeURIComponent(month || "")}`;
  console.log('collection params', params);
  const response = await bodycontent(params, "reports/collectionreceived.php");
  return handleApiResponse(response);

}

const getAllCustomerDataByCID = async (cID) => {
  try {
    const response = await bodycontent(`cId=${cID}`, 'Admin/get_agents_by_conference.php');
    console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchSFASizeForOrgDivision = async (division) => {
  try {
    const response = await bodycontent(`orgDiv=${division}`, 'orgDivSizexList.php');
    console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchAllGoodsReturnInfo = async (userCode, deliveryNumber, invoiceNumber) => {
  try {
    const response = await bodycontent(`userCode=${userCode}&deliveryNumber=${deliveryNumber}&invoiceNumber=${invoiceNumber}`, 'goods_return_invoice_details_list.php');
    console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchGoodsReturnMaterialList = async (goodsReturnInvoiceDtlsId) => {
  try {
    const response = await bodycontent(`goodsReturnInvoiceDtlsId=${goodsReturnInvoiceDtlsId}`, 'goods_return_info_list.php');
    console.error('Response:', response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchGoodsReturnStatusHistory = async (grInvoiceDtlsId) => {
  try {
    const response = await bodycontentnormal(`grInvoiceDtlsId=${grInvoiceDtlsId}`, 'getGoodsReturnStatusHistoryList.php');
    // console.error('Response:', response);
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchMonthsDropdown = async (userCode, type = "collection") => {
  try {
    const response = await bodycontent(`userCode=${userCode}&type=${type}`, 'reports/monthsdropdown.php');
    console.log('months dropdown', response)
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
}

const fetchDashboardReports = async (
  userCode,
  page,
  zone,
  partyCode,
  fromDate,
  toDate,
  zoneName
) => {
  const params =
    `userCode=${encodeURIComponent(userCode)}` +
    `&page=${encodeURIComponent(page)}` +
    `&zone=${encodeURIComponent(zone || "")}` +
    `&party=${encodeURIComponent(partyCode || "")}` +
    `&from_date=${encodeURIComponent(fromDate || "")}` +
    `&to_date=${encodeURIComponent(toDate || "")}` +
    `&zoneName=${encodeURIComponent(zoneName || "")}`;
  //   console.log('dashboard report params', params);
  const response = await bodycontent(params, "reports/dashboardreport.php");
  return handleApiResponse(response);

}

const fetchTopSalesQualityForStockBooking = async (userCode) => {
  const response = await fetchTop20SalesQualityReports(userCode);
  const list = Array.isArray(response?.topSalesQuality) ? response.topSalesQuality : [];
  return {
    status: Boolean(response?.status),
    topSalesQuality: list
  };
};

const fetchTop20SalesQualityReports = async (
  userCode
) => {
  const params =
    `userCode=${encodeURIComponent(userCode)}` +
    `&partyCode=${encodeURIComponent('')}`;
  //   console.log('dashboard report params', params);
  const response = await bodycontent(params, "reports/top20SalesQuality.php");
  return handleApiResponse(response);

}

const fetchCurrentMonthSalesReports = async (
  userCode,
  page,
  zone,
  divisions,
  partyCode,
  qualityPage,
  customerPage
) => {
  const params =
    `userCode=${encodeURIComponent(userCode)}` +
    `&page=${encodeURIComponent(page)}` +
    `&zone=${encodeURIComponent(zone || "")}` +
    `&subdivision=${encodeURIComponent(divisions || "")}` +
    `&party=${encodeURIComponent(partyCode || "")}` +
    `&qualityPage=${encodeURIComponent(qualityPage || "")}` +
    `&customerPage=${encodeURIComponent(customerPage || "")}` +
    `&customerLimit=${encodeURIComponent(100)}`;

  //   console.log('dashboard report params', params);
  const response = await bodycontent(params, "reports/currentmonthsalesfigure.php");
  return handleApiResponse(response);
};


export {
  loginApi,
  logoutApi,
  forgotPassApi,
  otpVerificaionApi,
  resetPasswordApi,
  getConfData,
  getCustomerData,
  getCustomerLeadgerData,
  getAgencyData,
  getDistributorData,
  getBarcodeScanData,
  Order,
  getOrdersData,
  getOrderDetails,
  getReplicateOrderDetails,
  getRetriveDetails,
  CheckoutOrder,
  getOrderReasonData,
  FabricCheckoutOrder,
  downalodFabricPdf,
  attedancereportData,
  myordersreportData,
  getTransportData,
  getCourierData,
  getDivisionData,
  getUserDivisionData,
  CustomerProfileApi,
  getCustomerProfileDetails,
  sendExtendCustomerProfileData,
  sampleCheckScanData,
  stockUpload,
  salesOrderUpload,
  cancelOrderAPI,
  getLedgerData,
  getVendorLedgerData,
  getVendorLedgerDetails,
  getPreviousLedgerDetails,
  getPreviousLedgerData,
  getLedgerDetails,
  getLedgerDivData,
  getLedgerDivDetails,
  downloadFiles,
  stockDownload,
  pendingOrdersDownload,
  pincodeData,
  getAssessmentScanData,
  addAssessmentScanData,
  getDivisionWiseOutstanding,
  getDivisionWiseOutstandingNew,
  getAssessmentReports,
  fetchUserBeats,
  fetchPlanningBeats,
  fetchBeatCustomers,
  uploadBeatPlanning,
  uploadBeatCustomerVisitRemark,
  fetchBeatCustomerOutstandingReport,
  fetchBeatCustomerSalesCompReport,
  fetchBeatCustomerCategoryCompReport,
  fetchProfitCenters,
  fetchPlantVisit,
  fetchSubject,
  fetchDivision,
  fetchUsers,
  postMarketIntelliagence,
  ProductCatalogueCSVUpload,
  fetchUserReports,

  // User Reports APIs
  fetchTargetAchievementReport,
  fetchCollectionsReport,
  fetchPendingDispatchReport,
  fetchOutstandingReport,
  fetchSalesReport,
  fetchStockLevelReport,

  // Sample Request APIs
  fetchSampleRequestBarcodesData,
  fetchSampleTypes,
  proceedsamplerequestorder,
  submitSampleRequestRemarkAPI, // Submit remark,
  fetchSampleRequestMonths,
  proceedsamplerequestorder90days,
  getSample90DaysMonthsReport,

  // Stock selection Garment Ratio
  fetchRatioOptions,
  postGoodAndReturns,
  getSampleRequestAccessAPI,

  // Goods return
  fetchUserParties,
  uploadGoodsReturnInfoDetails,
  uploadGoodsReturnTransferDetails,
  fetchAllGoodsReturnInfo,
  fetchGoodsReturnMaterialList,
  fetchGoodsReturnStatusHistory,

  fetchZonesPOReports,
  fetchDescriptionPOReports,
  fetchZonePartiesPOReports,
  fetchSubdivisionPOReports,
  fetchPendingOrderReports,
  fetchOutstandingReports,
  fetchNonBilledReports,
  fetchTargetSaleReport,
  fetchCollectionReceivedReports,
  fetchAllConferenceList,
  getAllCustomerDataByCID,

  fetchSFASizeForOrgDivision,
  fetchMonthsDropdown,
  fetchDashboardReports,
  fetchCurrentMonthSalesReports,
  fetchSalesPlanningBarcodesData,
  fetchTopSalesQualityForStockBooking
};
